export default __webpack_public_path__ + "img/6fc6a77873d9b9889612b6ba3dc35d06.png";